var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebFormCircleSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 26,
    rx: 3,
    fill: "#EFF6FF",
    stroke: "#3663FF",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4,
    width: 18,
    height: 2.5,
    rx: 1.25,
    fill: "#3663FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 9,
    width: 18,
    height: 1.5,
    rx: 0.75,
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13,
    width: 13,
    height: 1.5,
    rx: 0.75,
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 17,
    width: 18,
    height: 1.5,
    rx: 0.75,
    fill: "#94A3B8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 21,
    width: 12,
    height: 3,
    rx: 1.5,
    fill: "#3663FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFormCircleSmallIcon);
export default __webpack_public_path__ + "static/media/web-form-circle-small-icon.f37ba2ded2a59eeab3ce2ad5808661b7.svg";
export { ForwardRef as ReactComponent };